import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import RichText from 'legacy-src/utility/RichText';
import responsiveElementEnhancer from 'legacy/src/components/enhancers/ResponsiveElementEnhancer';
import { optionalSubmittable } from '../shared/survey';
import { answers } from '../shared/versions';
import './multiple_choice.scss';

class Player extends Component {
  static propTypes = {
    item: PropTypes.object,
    submission: PropTypes.object,
    style: PropTypes.oneOf(['default', 'grid']),
  };
  static breakpoints = {
    small: (e) => e.width < 710,
    default: (e) => e.width >= 710,
  };

  constructor(props) {
    super(props);

    this.state = {
      breakpoints: {
        default: true,
      },
    };
  }

  render() {
    const {
      item: { content },
      submission,
    } = this.props;
    const { selection = {}, submitted } = submission.state;
    const breakpoints = this.state.breakpoints;
    const style = content.style || 'default';
    const labelHidden = content.labelHidden;
    return (
      <div className="survey_question">
        <div
          className={cn(
            'survey_multiple_choice',
            style && `survey_multiple_choice_${style}`,
            { 'survey_multiple_choice--small': breakpoints.small },
          )}
        >
          <RichText
            className="multiple_choice__question"
            text={content.question}
          />
          <div className="multiple_choice__answers">
            {(content.answers || []).map((answer, index) => {
              const selected = selection[index];
              const props = {
                disabled: submitted,
                checked: selected,
                onChange() {
                  submission.setState({
                    selection: _.defaults({ [index]: !selected }, selection),
                  });
                },
              };
              if (style === 'default') {
                return (
                  <label
                    key={index}
                    className={cn('answer', {
                      'answer--checked': props.checked,
                    })}
                  >
                    <input type="checkbox" {...props} />
                    {labelHidden && !breakpoints.small ? null : (
                      <RichText text={answer.description} />
                    )}
                  </label>
                );
              }
              return (
                <label
                  key={index}
                  className={cn('answer', { 'answer--checked': props.checked })}
                >
                  {labelHidden && !breakpoints.small ? null : (
                    <RichText text={answer.description} />
                  )}
                  <input type="checkbox" {...props} />
                </label>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

Player.displayName = 'SurveyMultipleChoiceMultipleAnswer';

const component = responsiveElementEnhancer(Player);

export default { component, status: optionalSubmittable, version: answers };
